import {functions} from './lib/firebase/firebase.js';
import {validate, requiredFieldValidator, emailValidator, phoneNumberOptionalValidator, alphabetTextWithSpaceValidator, alphabetTextWithSpaceOptionalValidator} from './lib/validator.js';
import Swal from 'sweetalert2';

let form = document.getElementById("contact");

form.addEventListener("submit", (e) => {
	e.preventDefault();

	// Swal.fire({
	// 	icon: "success",
	// 	title: "Success",
	// 	text: "Your query has been sent!"
	// })


	let name = form.querySelector("#name");
	let email = form.querySelector("#email");
	let company = form.querySelector("#company");
	let phoneNumber = form.querySelector("#phone_number");
	let message = form.querySelector("#message");
	let button = document.getElementById("send-button");

	let formElements = [
		{
			field: name,
			validator: alphabetTextWithSpaceValidator,
			error_label: "name_error"
		},
		{
			field: email,
			validator: emailValidator,
			error_label: "email_error"
		},
		{
			field: company,
			validator: alphabetTextWithSpaceOptionalValidator,
			error_label: "company_error"
		},
		{
			field: phoneNumber,
			validator: phoneNumberOptionalValidator,
			error_label: "phone_number_error"
		},
		{
			field: message,
			validator: requiredFieldValidator,
			error_label: "message_error"
		}
	];

	if(validate(formElements)){
        button.textContent = "Sending...";
		let data = {
			name: name.value,
			email: email.value,
			company: company.value,
			phone_number: phoneNumber.value,
			message: message.value
		}
		
		let sendContactMail = functions.httpsCallable("sendContactMail");

		sendContactMail(data).then((result) => {
			Swal.fire({
				icon: "success",
				title: "Success",
				text: "Your query has been sent!"
            })
			button.textContent = "Send Message";
		form.reset()
			
            
		}).catch((error) => {
			Swal.fire({
				icon: 'error',
				title: 'Oops',
				text: "Something went wrong"
            })
            button.textContent = "Send Message";
            
		})


	}
});
